
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-item/[id]",
      function () {
        return require("private-next-pages/facility-item/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-item/[id]"])
      });
    }
  